enum DocumentsRoutesEnum {
  DocumentsList = '/documents',
  PackageDetails = '/documents/user/:clientId/package/:packageId',
}

export default DocumentsRoutesEnum;
